<template>
    <views>
        <views v-if="value.type === 1" class="improve-info-list">
            <views class="improve-info-label">
                {{ value.name }}
                <views v-if="value.is_required" class="require">*</views>
            </views>
            <views class="improve-info-value">
                <drawer v-model="value" @ok="ok"></drawer>
                <!-- <select v-model="value.value" :class="{'default': value.value === ''}"> -->
                    <!-- <option value="" disabled style='display:none;'>{{ value.tip }}</option> -->
                    <!-- <option
                        v-for="(item, index) in value.choose_value"
                        :key="index"
                        :value="item">
                        {{ item }}
                    </option> -->
                <!-- </select> -->
            </views>
        </views>
        <views v-if="value.type === 2" class="improve-info-list">
            <views class="improve-info-label">
                {{ value.name }}
                <views v-if="value.is_required" class="require">*</views>
            </views>
            <views class="improve-info-value">
                <input type="text" :placeholder="value.tip" v-model="value.value">
            </views>
        </views>
        <views v-if="value.type === 3" class="improve-info-list">
            <views class="improve-info-label">
                {{ value.name }}
                <views v-if="value.is_required" class="require">*</views>
            </views>
            <views class="improve-info-value">
                <input type="number" pattern="[0-9]*" :placeholder="value.tip" v-model="value.value">
            </views>
        </views>
        <views v-if="value.type === 4" class="improve-info-title">{{ value.name }}</views>
    </views>
</template>

<script>
import Drawer from '@/components/drawer'
export default {
    components: {
        Drawer
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        ok(val) {
            console.log(val)
            this.$emit('input', val)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import './index.scss';
</style>
